import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './dossier.action';

@Injectable({ providedIn: 'root' })
export class DossierTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                id: '',
                debtor_name: '',
                club_name: null,
                outstanding_status: '1',
                outstanding_with_fee: '',
                is_paid: null,
                dossier_categories_name: null,
                season_name: '',
                is_single_payment_dossier: null
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at'; //season_name
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubId = 0;
    memberId = 0;
    
    clubs = [];
    categories = [];
    statuses = [
        {id: "0", value: "DOSSIER.pending"},
        {id: "1", value: "DOSSIER.paid"},
        {id: "2", value: "DOSSIER.uncollectable"},
    ];

    outstandings = [
        {"id": "1", "name": "COMMON.yes"},
        {"id": "0", "name": "COMMON.no"}
    ];

    types = [
        {id: "0", name: "DOSSIER.contribution"},
        {id: "1", name: "DOSSIER.fee"},
    ];
    
    columns = [
                { prop: 'id', name: 'DOSSIER.id', sortable: true, hasFilter: true, filter: "input", widthSet: 70},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 145},
                { prop: 'dossier_categories_name', name: 'DOSSIER.category', sortable: true, hasFilter: true, filter: "select", options: 'categories', options_id: "id", options_label: "name", widthSet: 185},
                { prop: 'is_single_payment_dossier', name: 'DOSSIER.type', sortable: true, hasFilter: true, filter: "select", options: 'types', options_id: "id", options_label: "name", widthSet: 110},
                { prop: 'debtor_name', name: 'DOSSIER.debtor-name', sortable: true, hasFilter: true, filter: "input", widthSet: 185},
                { prop: 'club_name', name: 'DOSSIER.club', sortable: true, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name", widthSet: 220},
                { prop: 'outstanding_status', name: 'DOSSIER.outstanding', sortable: true, hasFilter: true, filter: "select", options: 'outstandings', options_id: "id", options_label: "name" , widthSet: 100},
                { prop: 'outstanding_with_fee', name: 'DOSSIER.amount', sortable: true, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'is_paid', name: 'DOSSIER.payment-status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "value", widthSet: 180},
                // { prop: 'season_name', name: 'DOSSIER.season-name', sortable: true, hasFilter: true, filter: "input", widthSet: 110},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: "", minWidth: 100},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){
        if(
            Object.entries(this.filters).some(([key, value]) => {
                if (key === 'outstanding_status'){
                    return value != '1';
                }
                return value !== '' && value !== null;
            }) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetState(){
        this.filters = {
            created_at: '',
            id: '',
            debtor_name: '',
            club_name: null,
            outstanding_status: '1',
            outstanding_with_fee: '',
            is_paid: null,
            dossier_categories_name: null,
            season_name: '',
            is_single_payment_dossier: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}